var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"320px"},attrs:{"id":"onlineService_"+_vm.query.gbType}})
}
var staticRenderFns = []

export { render, staticRenderFns }